module.exports = __webpack_public_path__ + "static/img/ico_completion.7754e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/_images/ico_completion.png
// module id = jtRh
// module chunks = 0